// extracted by mini-css-extract-plugin
export default {"container":"HeaderLogo_container__ROQMy","avatar":"HeaderLogo_avatar__T65c9"};